import { Component, Input } from '@angular/core';

import { SnShareDirection } from '@lib/api/entities';
import { t } from '@lib/translation';

import { ISnIsSharable } from '../../interfaces';

@Component({
  selector: 'sn-object-owner',
  styleUrls: ['./object-owner.component.scss'],
  templateUrl: './object-owner.component.html',
})
export class SnObjectOwnerComponent {
  @Input()
  set object(value: ISnIsSharable) {
    this.owner =
      value.isShared && value.shareInfo.direction === SnShareDirection.In
        ? value.organization.name
        : t('common.me');
  }

  public owner: string;

  constructor() {}
}
